import { AsyncPropSelector, CurrencyText } from '@nile/components';
import {
  Button,
  ButtonGroup,
  Popover,
  TextStyle
} from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { EditIcon } from '@nile/components/src/Icons';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
`;

const Field = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  .Polaris-ButtonGroup {
    margin-top: 12px;
  }
`;

function CurrencyCell(props) {
  const { cell, params, _ticket } = props;
  const allProps = params || cell.column;
  const { editable, field, actions, accessor, entity } = allProps;
  const ticket = _ticket || cell.row.original;
  const [popoverActive, setPopoverActive] = useState(false);
  const [updatedProperties, setUpdatedProperties] = useState({});
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;

  const updateSelectedProperties = (key, value) => {
    setUpdatedProperties({
      ...updatedProperties,
      [key]: value
    });
  };

  const updateSelection = (f, val) => {
    let serialisedValue = null;
    if (field.isCustom) {
      updateSelectedProperties('customFields', val);
    } else {
      switch (field.name) {
        case 'techGroup':
          serialisedValue = { groupId: val.groupId, name: val.name };
          break;
        case 'technician':
          serialisedValue = { userId: val.userId };
          break;
        case 'sop':
          serialisedValue = { sopId: val.sopId, name: val.name };
          break;
        default:
          serialisedValue = val.name;
      }
      updateSelectedProperties(field.name, serialisedValue);
    }
  };

  const getTag = () => {
    const fieldValue = updatedProperties[field.name] || ticket[field.name];
    const defaultValue = fieldValue
      ? typeof fieldValue === 'object'
        ? {
            name: fieldValue.name,
            label: fieldValue.name,
            value: fieldValue.name
          }
        : { name: fieldValue, label: fieldValue, value: fieldValue }
      : '';
    return (
      <Field>
        <AsyncPropSelector
          defaultValue={defaultValue}
          updateSelection={updateSelection}
          ticket={ticket}
          field={field}
          entity={entity || 'Ticket'}
        />
        <div className="mt10">
          <ButtonGroup>
            <Button
              onClick={() => {
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Cancel
            </Button>
            <Button
              primary
              onClick={() => {
                actions.save &&
                  actions.save(updatedProperties, ticket, props.data);
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Save
            </Button>
          </ButtonGroup>
        </div>
      </Field>
    );
  };
  //TODO :: render value in a proper way for NA - vignesh
  const displayVal = cell
    ? props.column.subAccessor
      ? cell.value[props.column.subAccessor]
      : cell.value
      ? cell.value.name || cell.value
      : ''
    : ticket[accessor]
    ? typeof ticket[accessor] === 'object'
      ? ticket[accessor].name
        ? ticket[accessor].name
        : ticket[accessor].firstName
        ? ticket[accessor].firstName + ' ' + ticket[accessor].lastName
        : ticket[accessor].label
      : ticket[accessor]
    : '';

  const getDisplayValue = () => {
    if (cell) {
      if (props?.column?.subAccessor) {
        return cell?.value?.[props.column.subAccessor];
      }
      return cell.value ? cell.value.name || cell.value : null;
    }
    if (ticket[accessor]) {
      if (typeof ticket?.[accessor] === 'object') {
        if (ticket[accessor].name) return ticket[accessor].name;
        return ticket[accessor].firstName
          ? `${ticket[accessor].firstName} ${ticket[accessor].lastName}`
          : ticket[accessor].label;
      }
      return ticket?.[accessor];
    }
    return null;
  };

  const displayValue = getDisplayValue();

  return !popoverActive ? (
    <Wrap className={`${editable ? 'editable-cell' : 'cell'}`}>
      <div className="ellipsis" title={displayValue}>
        {displayValue ? (
          <div className="fx g10">
            <TextStyle weight="Bold">
              <CurrencyText value={displayValue / 100} />
            </TextStyle>
          </div>
        ) : (
          <TextStyle variation="subdued">NA</TextStyle>
        )}
      </div>
      {editable && <div className="edit-actions">{activator}</div>}
    </Wrap>
  ) : (
    <Wrap className="editable-cell">
      <div className="ellipsis" title={displayValue}>
        {displayValue ? (
          <div className="fx g10">
            <TextStyle weight="Bold">
              <CurrencyText value={displayValue / 100} />
            </TextStyle>
          </div>
        ) : (
          <TextStyle variation="subdued">NA</TextStyle>
        )}
      </div>
      <Popover activator={activator} active={popoverActive} onClose={() => {}}>
        {getTag()}
      </Popover>
    </Wrap>
  );
}

export default CurrencyCell;
